@keyframes shimmer {
    0% {
        transform: translateX(-100%);
    }
    100% {
        transform: translateX(100%);
    }
}

.chat_avatar_placeholder {
    &:where([data-animate])::after {
        animation: shimmer 2s infinite;
        background: linear-gradient(
            to right,
            var(--mantine-color-dark-7),
            var(--mantine-color-dark-5),
            var(--mantine-color-dark-7)
        );
    }

    &:where([data-visible]) {
        &::after {
            background-color: var(--mantine-color-dark-7);
        }
    }
}

.chat_avatar {
    --avatar-bg: var(--mantine-color-dark-7);
    --avatar-color: var(--mantine-color-gray-2);
}

/* Styling for the notification countdown ring */
.notification_ring {
    display: flex;
    justify-content: center;
    align-items: center;
    margin: 0;
    padding: 0;
    position: relative;
    overflow: visible;
}

.notification_ring_label {
    display: flex;
    justify-content: center;
    align-items: center;
    position: relative; /* Ensure proper positioning of children */
    width: 100%;
    height: 100%;
    z-index: 1;
}
